import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-042719c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["element-loading-text"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "fc-d fw-700" }
const _hoisted_4 = { class: "fc-d fw-700" }
const _hoisted_5 = {
  key: 1,
  style: {"margin-top":"10px"}
}

import { ref, unref, reactive, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import { useAppStore } from '@/store/app';
import { GetWorkTimeLineApi } from '@/apis/tasks/task.api';
import { AuditUrgeApi } from '@/apis/contract/contract.api';
import moment from 'moment';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const { t } = useI18n();
const login = useAppStore().getLoginInfo;

const state = reactive({
	show: false,
	loading: false,
	urgeLoad: false,
	contractId: '',
	createUserId: '',
	workList: [] as any[],
});

const load = {
	/* 获取审批流程记录 */
	getWorkListData: (contractId: string) => {
		state.loading = true;
		GetWorkTimeLineApi(contractId)
			.then((res) => {
				if (!res.succeeded) {
					ElMessage.error(`流程数据读取失败，可能的原因是:${res.errors}`);
				} else {
					state.workList = res.data;
				}
			})
			.finally(() => (state.loading = false));
	},
};

const actions = {
	/* 催办 */
	onUrgeBtnClick: (workId: string) => {
		state.urgeLoad = true;
		AuditUrgeApi(workId)
			.then((res) => {
				if (!res.succeeded) {
					ElMessage.error(`操作失败，可能的原因是：${res.errors}`);
				} else {
					ElMessage.success(t('auditLocus.buttons.urge') + t('notify.success'));
					if (state.contractId) load.getWorkListData(state.contractId);
				}
			})
			.finally(() => (state.urgeLoad = false));
	},
	/* 刷新数据 */
	onRefreshBtnClick: () => {
		if (state.contractId) load.getWorkListData(unref(state.contractId));
	},
};

/* 公开的方法 */
const methods = {
	showDrawer: (ctId: string, insEmpNo: string) => {
		load.getWorkListData(ctId);
		state.contractId = ctId;
		state.createUserId = insEmpNo;
		state.show = true;
	},
};

expose({ ...methods });

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: _unref(state).show,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).show) = $event)),
    title: _unref(t)('auditLocus.title')
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          onClick: actions.onRefreshBtnClick
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('auditLocus.buttons.refreshData')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", {
        style: {"margin-top":"20px"},
        "element-loading-text": _unref(t)('auditLocus.loading')
      }, [
        ((_unref(state).workList || []).length > 0)
          ? (_openBlock(), _createBlock(_component_el_timeline, {
              key: 0,
              style: {"min-height":"150px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).workList, (item) => {
                  return (_openBlock(), _createBlock(_component_el_timeline_item, {
                    timestamp: item.node_name,
                    placement: "top",
                    hollow: true
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h4", {
                        class: _normalizeClass(item.work_status_desc == '待处理' ? 'waittodo' : 'finish')
                      }, _toDisplayString(_unref(t)('auditLocus.timeline.handler')) + _toDisplayString(item.emp_name) + "(" + _toDisplayString(item.emp_no) + ")，" + _toDisplayString(_unref(t)('auditLocus.timeline.action')) + _toDisplayString(item.work_status_desc), 3),
                      _createElementVNode("p", null, _toDisplayString(_unref(t)('auditLocus.timeline.operationTime')) + _toDisplayString(item.action_date ? item.action_date : '--'), 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(t)('auditLocus.timeline.approvalOpinion')) + _toDisplayString(item.remark || '--'), 1),
                      (item.urge_total > 0 && item.work_status == '0')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                            _createTextVNode(_toDisplayString(_unref(t)('auditLocus.timeline.urged')) + " ", 1),
                            _createElementVNode("span", _hoisted_3, _toDisplayString(item.urge_total) + _toDisplayString(_unref(t)('auditLocus.timeline.times')), 1),
                            _createTextVNode(" " + _toDisplayString(_unref(t)('auditLocus.timeline.recentUrge')) + " ", 1),
                            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(moment)(item.urge_time).format('YYYY-MM-DD HH:mm')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (item.work_status == '0' && _unref(state).createUserId == _unref(login).user_account && item.emp_no != _unref(login).user_account)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              size: "small",
                              loading: _unref(state).urgeLoad,
                              onClick: ($event: any) => (actions.onUrgeBtnClick(item.id))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('auditLocus.buttons.urge')), 1)
                              ]),
                              _: 2
                            }, 1032, ["loading", "onClick"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["timestamp"]))
                }), 256))
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_el_empty, {
              key: 1,
              size: "small",
              description: _unref(t)('auditLocus.empty') 
            }, null, 8, ["description"]))
      ], 8, _hoisted_1)), [
        [_directive_loading, _unref(state).loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})